module.exports = __webpack_public_path__ + "img/ico-survey.221a52b7.svg";